import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core';
import { Dashboard as DashboardLayout } from 'layouts';
import { connect } from "react-redux";

// Component styles
import styles from './styles';
import { SupportTable } from './components';

class Support extends Component {
  render() {
    const { classes } = this.props;
    return (
      <DashboardLayout title="Support">
        <div className={classes.root}>
          <div className={classes.content}>
            <SupportTable/>
          </div>
        </div>
      </DashboardLayout>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

Support.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(Support);
